export default __webpack_public_path__ + "static/about-banner-061bfd4403712e326d1f9c7d776fea87.jpg";